import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {FiltersService} from '../../search/search-list/filters/filters.service';
import {NavBaseComponent} from '../nav-base/nav-base.component';
import {HtmlUtilsService} from "../../html-utils/html-utils.service";

@Component({
  selector: 'app-nav-logo',
  templateUrl: './nav-logo.component.html',
  styleUrls: ['../nav-base/nav-base.component.scss']
})
export class NavLogoComponent extends NavBaseComponent {
  highContrast: boolean = false;

  constructor(private router: Router,
              private filtersService: FiltersService,
              private htmlUtils: HtmlUtilsService) {
    super();
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
      }
    });
  }

  navigateToHome() {
    this.filtersService.allRegularFacets.next([]);
    this.router.navigate(['/'], {queryParams: {root: true}});
  }

}
